import { campaigns } from '@/_data/campaigns_data';
import { useCurrentUser } from '@/hooks/data/user';
import moment from 'moment';
import Image from 'next/image';
import Link from 'next/link';

export default function Fall23Widget() {
   const summerCampaignData = campaigns.fall23;
   const currentUser = useCurrentUser();

   if (moment().isBefore(summerCampaignData.startDate) || moment().isAfter(summerCampaignData.endDate)) {
      return null;
   }

   if (currentUser?.user?.isPremium) {
      return (
         <div>
            <Link href={summerCampaignData.link} passHref target="_blank">
               <Image
                  src="/images/campaigns/fall23/fall 2023.svg"
                  width={500}
                  height={500}
                  alt="Summer 23 Banner"
                  style={{
                     objectFit: 'cover',
                     width: '100%',
                     height: 'auto',
                  }}
               />
            </Link>
         </div>
      );
   }
}
